'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { useAuth } from '@sola/auth-sdk/store.tsx';
import type { IconNames } from '@sola/schema/lib/icons/icon-names.ts';
import { trackClick } from '@sola/tracking/components/datalayer.tsx';
export const LogoutButton: React.FC<{
  title?: string;
  icon?: IconNames;
  className?: string;
}> = t0 => {
  const $ = _c(21);
  const {
    title,
    icon,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["priority"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const {
    actions: authActions
  } = useAuth("actions");
  let t2;
  if ($[1] !== authActions || $[2] !== t || $[3] !== title) {
    t2 = async () => {
      trackClick(title || t("priority:nav.logOut"));
      return authActions.logOut();
    };
    $[1] = authActions;
    $[2] = t;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const logOut = t2;
  let t3;
  if ($[5] !== className) {
    t3 = cn("LinkList__menu-link LogoutButton w-full", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== icon) {
    t4 = icon && <ArkIcon iconName={icon} className="LinkList__icon" />;
    $[7] = icon;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t || $[10] !== title) {
    t5 = title || t("priority:nav.logOut");
    $[9] = t;
    $[10] = title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <span className="label flex gap-snug-xl items-center label-potent label-lg">{t5}</span>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== logOut || $[15] !== t4 || $[16] !== t6) {
    t7 = <LinkStyle size="sm" purpose="negative" noUnderline={true}><button type="button" onClick={logOut} className="w-full flex gap-snug-xl">{t4}{t6}</button></LinkStyle>;
    $[14] = logOut;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t3 || $[19] !== t7) {
    t8 = <div className={t3}>{t7}</div>;
    $[18] = t3;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};